cb.define(['common/common_VM.Extend.js'], function(common) {
	//var _util = require('../../../helpers/util');

	var ST_st_storecheckplan_VM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		deleteAllRows: function(gridModel) {
			var rowsCount = gridModel.getRowsCount();
			var rowIndexes = [];
			for(var i = 0; i < rowsCount; i++)
				rowIndexes.push(i);
			gridModel.deleteRows(rowIndexes);
		},
		deleteAllItems: function(tagModel) {
			var rowsCount = tagModel.getShowValueCount();
			var rowIndexes = [];
			for(var i = 0; i < rowsCount; i++)
				rowIndexes.push(i);
			tagModel.deleteItems(rowIndexes);
		},
		formatter: function(planGridModel, viewModel) {
			var self = this;
			//已盘漏盘复盘的样式
			planGridModel.setColumnState('checkstatus', 'formatter', function(rowInfo, rowData) {
				var checkstatus = rowData.checkstatus.value;
				var className = '';
				switch(checkstatus) {
					case '0':
						className = 'have-disk-green';
						break;
					case '1':
						className = 'leaking-plate-red';
						break;
					case '2':
						className = 'replay-blue';
						break;
				}
				return {
					override: true,
					html: '<span class="' + className + '">' + rowData.checkstatus.text + '</span>'
				}
			});

			//盘盈盘亏平的样式
			planGridModel.setColumnState('profitlossqty', 'formatter', function(rowInfo, rowData) {
				var profitlossqty = parseFloat(rowData.profitlossqty).toFixed(cb.rest.AppContext.option.quantitydecimal);
				var className = '';

				if(profitlossqty == 0) {
					className = 'normal-grey';
				} else if(profitlossqty > 0) {
					className = 'overage-green';
				} else {
					className = 'loss-red';
				}
				return {
					override: true,
					html: '<span class="' + className + '">' + profitlossqty + '</span>'
				}
			});
		},
		init: function(viewmodel) {
			var self = this;
			viewmodel.getParams().saveReturn = false;
			viewmodel.get('productClass').setState('checkStrictly', false);
			var resultGridModel = viewmodel.get('resultdetails');
			resultGridModel.setShowCheckbox(true); //使表体行可以勾选
			self.formatter(resultGridModel, viewmodel);
			resultGridModel.on('afterSetColumns', function() {
				self.formatter(resultGridModel, viewmodel);
			});

			// 参数：是否生单
			var checkInventorySheetGenerate = false;
			// 参数：是否珠宝行业
			var jewelleryIndustry = true;

			var originSkuRows = viewmodel.get('resultdetails').getRows();
			viewmodel.on('filterClick', function(params) {
				//点击搜索的时候，过滤条件就会传到这里，这里根据过滤条件处理resultGridModel中的数据，处理好以后给resultGridModel再设置一遍setdatasource
				var resultRows = [];
				var filtered = false;
				if(params.condition.commonVOs != null && params.condition.commonVOs != undefined && params.condition.commonVOs !== '' && params.condition.commonVOs.length > 2) {
					for(var i = 2; i < params.condition.commonVOs.length; i++) {
						//盘点状态：0已盘1漏盘2复盘
						if(params.condition.commonVOs[i].itemName != null && params.condition.commonVOs[i].itemName != undefined && params.condition.commonVOs[i].itemName !== '' && params.condition.commonVOs[i].itemName == 'checkstatus') {
							var filter1Rows = [];
							if(params.condition.commonVOs[i].value1 == '0') {
								filtered = true;
								for(var j = 0; j < originSkuRows.length; j++) {
									if(originSkuRows[j].checkstatus != null && originSkuRows[j].checkstatus != undefined && originSkuRows[j].checkstatus !== '' && originSkuRows[j].checkstatus == '0') {
										filter1Rows.push(originSkuRows[j]);
									}
								}
							} else if(params.condition.commonVOs[i].value1 == '1') {
								filtered = true;
								for(var j = 0; j < originSkuRows.length; j++) {
									if(originSkuRows[j].checkstatus != null && originSkuRows[j].checkstatus != undefined && originSkuRows[j].checkstatus !== '' && originSkuRows[j].checkstatus == '1') {
										filter1Rows.push(originSkuRows[j]);
									}
								}
							} else if(params.condition.commonVOs[i].value1 == '2') {
								filtered = true;
								for(var j = 0; j < originSkuRows.length; j++) {
									if(originSkuRows[j].checkstatus != null && originSkuRows[j].checkstatus != undefined && originSkuRows[j].checkstatus !== '' && originSkuRows[j].checkstatus == '2') {
										filter1Rows.push(originSkuRows[j]);
									}
								}
							}
							resultRows = filter1Rows;
						}

						//盈亏状态：0盘盈1盘亏2差异
						if(params.condition.commonVOs[i].itemName != null && params.condition.commonVOs[i].itemName != undefined && params.condition.commonVOs[i].itemName !== '' && params.condition.commonVOs[i].itemName == 'profitAndLoss') {
							var filter2Rows = [];
							var skuRows = [];
							if(filtered == true) {
								skuRows = resultRows;
							} else {
								skuRows = originSkuRows;
							}

							if(params.condition.commonVOs[i].value1 == '0') {
								filtered = true;
								for(var j = 0; j < skuRows.length; j++) {
									if(skuRows[j].profitlossqty != null && skuRows[j].profitlossqty != undefined && skuRows[j].profitlossqty !== '' && skuRows[j].profitlossqty > 0) {
										filter2Rows.push(skuRows[j]);
									}
								}
							} else if(params.condition.commonVOs[i].value1 == '1') {
								filtered = true;
								for(var j = 0; j < skuRows.length; j++) {
									if(skuRows[j].profitlossqty != null && skuRows[j].profitlossqty != undefined && skuRows[j].profitlossqty !== '' && skuRows[j].profitlossqty < 0) {
										filter2Rows.push(skuRows[j]);
									}
								}
							} else if(params.condition.commonVOs[i].value1 == '2') {
								filtered = true;
								for(var j = 0; j < skuRows.length; j++) {
									if(skuRows[j].profitlossqty != null && skuRows[j].profitlossqty != undefined && skuRows[j].profitlossqty !== '' && skuRows[j].profitlossqty != 0) {
										filter2Rows.push(skuRows[j]);
									}
								}
							}
							resultRows = filter2Rows;
						}

						//盈亏数量
						if(params.condition.commonVOs[i].itemName != null && params.condition.commonVOs[i].itemName != undefined && params.condition.commonVOs[i].itemName !== '' && params.condition.commonVOs[i].itemName == 'profitlossqty') {
							var filter3Rows = [];
							var skuRows = [];
							if(filtered == true) {
								skuRows = resultRows;
							} else {
								skuRows = originSkuRows;
							}

							//如果两个都是空的，那么不会作为条件收集到这里，所以这里只需要判断其中一个为空和两个都不为空即可
							if(params.condition.commonVOs[i].value2 == null || params.condition.commonVOs[i].value2 == undefined || params.condition.commonVOs[i].value2 == '') {
								filtered = true;
								var profitlossqtySmaller = params.condition.commonVOs[i].value1;
								for(var j = 0; j < skuRows.length; j++) {
									if(skuRows[j].profitlossqty != null && skuRows[j].profitlossqty != undefined && skuRows[j].profitlossqty !== '' && skuRows[j].profitlossqty >= profitlossqtySmaller) {
										filter3Rows.push(skuRows[j]);
									}
								}
							} else if(params.condition.commonVOs[i].value1 == null || params.condition.commonVOs[i].value1 == undefined || params.condition.commonVOs[i].value1 == '') {
								filtered = true;
								var profitlossqtyBigger = params.condition.commonVOs[i].value2;
								for(var j = 0; j < skuRows.length; j++) {
									if(skuRows[j].profitlossqty != null && skuRows[j].profitlossqty != undefined && skuRows[j].profitlossqty !== '' && skuRows[j].profitlossqty <= profitlossqtyBigger) {
										filter3Rows.push(skuRows[j]);
									}
								}
							} else if(params.condition.commonVOs[i].value1 != null && params.condition.commonVOs[i].value1 != undefined && params.condition.commonVOs[i].value1 !== '' &&
								params.condition.commonVOs[i].value2 != null && params.condition.commonVOs[i].value2 != undefined && params.condition.commonVOs[i].value2 !== '') {
								filtered = true;
								var profitlossqtySmaller = params.condition.commonVOs[i].value1;
								var profitlossqtyBigger = params.condition.commonVOs[i].value2;
								for(var j = 0; j < skuRows.length; j++) {
									if(skuRows[j].profitlossqty != null && skuRows[j].profitlossqty != undefined && skuRows[j].profitlossqty !== '' && skuRows[j].profitlossqty >= profitlossqtySmaller && skuRows[j].profitlossqty <= profitlossqtyBigger) {
										filter3Rows.push(skuRows[j]);
									}
								}
							}
							resultRows = filter3Rows;
						}

						//商品
						if(params.condition.commonVOs[i].itemName != null && params.condition.commonVOs[i].itemName != undefined && params.condition.commonVOs[i].itemName !== '' && params.condition.commonVOs[i].itemName == 'product') {
							var filter4Rows = [];
							var skuRows = [];
							if(filtered == true) {
								skuRows = resultRows;
							} else {
								skuRows = originSkuRows;
							}

							if(params.condition.commonVOs[i].value1 != null && params.condition.commonVOs[i].value1 != undefined && params.condition.commonVOs[i].value1 !== '') {
								filtered = true;
								var product = params.condition.commonVOs[i].value1;
								for(var j = 0; j < skuRows.length; j++) {
									if(skuRows[j].product != null && skuRows[j].product != undefined && skuRows[j].product !== '' && skuRows[j].product == product) {
										filter4Rows.push(skuRows[j]);
									}
								}
							}
							resultRows = filter4Rows;
						}

						//sku
						if(params.condition.commonVOs[i].itemName != null && params.condition.commonVOs[i].itemName != undefined && params.condition.commonVOs[i].itemName !== '' && params.condition.commonVOs[i].itemName == 'productsku') {
							var filter5Rows = [];
							var skuRows = [];
							if(filtered == true) {
								skuRows = resultRows;
							} else {
								skuRows = originSkuRows;
							}

							if(params.condition.commonVOs[i].value1 != null && params.condition.commonVOs[i].value1 != undefined && params.condition.commonVOs[i].value1 !== '') {
								filtered = true;
								var productsku = params.condition.commonVOs[i].value1;
								for(var j = 0; j < skuRows.length; j++) {
									if(skuRows[j].productsku != null && skuRows[j].productsku != undefined && skuRows[j].productsku !== '' && skuRows[j].productsku == productsku) {
										filter5Rows.push(skuRows[j]);
									}
								}
							}
							resultRows = filter5Rows;
						}
					}
					if(filtered == true) {
						resultGridModel.setDataSource(resultRows);
					} else {
						resultGridModel.setDataSource(originSkuRows);
					}
				} else {
					resultGridModel.setDataSource(originSkuRows);
				}
			});
			
			viewmodel.on('tabActiveKeyChange', function(params) {
				//点击的页签是复核页签的时候，如果未复核，就向后台发送请求，组装数据，组装好数据以后，给resultGridModel setdatasource
				var status = viewmodel.get("status").getValue();
				if(params.key != null && params.key !== '' && params.key !== undefined && params.key == 'fuhe_yeqian' &&
					status != null && status !== '' && status !== undefined && status == '0'
				) {
					//向后台发送请求组装数据
					resultGridModel.setReadOnly(false);
					var promise = new cb.promise();
					var params = {
						tenant: cb.rest.AppContext.tenant.id,
						store: viewmodel.get("store").getValue(),
						warehouse: viewmodel.get("warehouse").getValue(),
						storecheckplan: viewmodel.get("id").getValue(),
						details: viewmodel.get("details").getRows(),
						checkStartTime: viewmodel.get("checkStartTime").getData()
					};

					var getReviewData = cb.rest.DynamicProxy.create({
						settle: {
							url: '/billingretail/getReviewData',
							method: 'POST'
						}
					});

					getReviewData.settle(params, (err, result) => {
						// getGridModel.insertRows(0,[{b:'',a:'',c:''}]);
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}

						if(result === undefined) {
							cb.utils.alert("数据组装异常！", 'error');
							return;
						}

						if(result != null && result != undefined && result !== '' && result.length > 0) {
							for(var i = 0; i < result.length; i++) {
								var quantity = 0;
								if(result[i].quantity != null && result[i].quantity != undefined && result[i].quantity !== '') {
									quantity = result[i].quantity;
								}
								var accountQty = 0;
								if(result[i].accountQty != null && result[i].accountQty != undefined && result[i].accountQty !== '') {
									accountQty = result[i].accountQty;
								}
								var occurredqty = 0;
								if(result[i].occurredqty != null && result[i].occurredqty != undefined && result[i].occurredqty !== '') {
									occurredqty = result[i].occurredqty;
								}
								result[i].profitlossqty = quantity - accountQty - occurredqty;
							}
							resultGridModel.setDataSource(result);
							originSkuRows = viewmodel.get('resultdetails').getRows();
						}
						promise.resolve();
					});
					return promise;
				}

				//按钮可见性
				if(status != null && status !== '' && status !== undefined && status == '0') {
					if(viewmodel.get('btnReAudit')) {
						viewmodel.get('btnReAudit').setVisible(true);
					}
					if(viewmodel.get('btnReCheck')) {
						viewmodel.get('btnReCheck').setVisible(true);
					}
					if(viewmodel.get('btnQueryOthOut')) {
						viewmodel.get('btnQueryOthOut').setVisible(false);
					}
					if(viewmodel.get('btnQueryOthIn')) {
						viewmodel.get('btnQueryOthIn').setVisible(false);
					}
				} else if(status != null && status !== '' && status !== undefined && status == '1') {
					if(viewmodel.get('btnReAudit')) {
						viewmodel.get('btnReAudit').setVisible(false);
					}
					if(viewmodel.get('btnReCheck')) {
						viewmodel.get('btnReCheck').setVisible(false);
					}
					if(viewmodel.get('btnQueryOthOut')) {
						if(checkInventorySheetGenerate) {
							viewmodel.get('btnQueryOthOut').setVisible(true);
							viewmodel.get('btnQueryOthOut').setDisabled(false);
						} else {
							viewmodel.get('btnQueryOthOut').setVisible(false);
						}

					}
					if(viewmodel.get('btnQueryOthIn')) {
						if(checkInventorySheetGenerate) {
							viewmodel.get('btnQueryOthIn').setVisible(true);
							viewmodel.get('btnQueryOthIn').setDisabled(false);
						} else {
							viewmodel.get('btnQueryOthIn').setVisible(false);
						}

					}
				}
			});
			var planGridModel = viewmodel.get('details');

			var checkStartTime;
			var from = '0'; //snapshot表示该请求来自生成快照按钮，specifyproduct表示该请求来自增行

			if(viewmodel.getParams().mode === 'add' || viewmodel.getParams().mode === 'edit') {
				//作废、编辑、删除不可见
				if(viewmodel.get('btnInvalidSCPlan')) {
					viewmodel.get('btnInvalidSCPlan').setVisible(false);
				}
				if(viewmodel.get('btnEdit')) {
					viewmodel.get('btnEdit').setVisible(false);
				}
				if(viewmodel.get('btnDelete')) {
					viewmodel.get('btnDelete').setVisible(false);
				}
				if(viewmodel.get('btnSnapshot')) {
					viewmodel.get('btnSnapshot').setVisible(true);
					viewmodel.get("btnSnapshot").setDisabled(false);
				}

				//如果是按品类盘点，那么盘点品类可编辑，否则不可编辑
				var storeCheckRange = viewmodel.get("storeCheckRange").getValue();
				if(storeCheckRange != null && storeCheckRange != undefined && storeCheckRange !== '' && storeCheckRange == '1') {
					viewmodel.get("productClass").setDisabled(false);
				} else {
					viewmodel.get("productClass").setDisabled(true);
				}
			}
			var mode = viewmodel.getParams().mode;
			viewmodel.on("afterEdit", function(data) {
				if(viewmodel.get('btnInvalidSCPlan')) {
					viewmodel.get('btnInvalidSCPlan').setVisible(false);
				}
				if(viewmodel.get('btnEdit')) {
					viewmodel.get('btnEdit').setVisible(false);
				}
				if(viewmodel.get('btnDelete')) {
					viewmodel.get('btnDelete').setVisible(false);
				}
				if(viewmodel.get('btnExport')) {
					viewmodel.get('btnExport').setVisible(false);
				}

				//如果是整仓盘点和指定品类盘点，那么生成快照可见
				var storeCheckRange = viewmodel.get("storeCheckRange").getValue();
				if(storeCheckRange != null && storeCheckRange != undefined && storeCheckRange !== '' &&
					(storeCheckRange == '0' || storeCheckRange == '1')) {
					if(viewmodel.get('btnSnapshot')) {
						viewmodel.get('btnSnapshot').setVisible(true);
						viewmodel.get("btnSnapshot").setDisabled(false);
					}
				} else {
					if(viewmodel.get('btnSnapshot')) {
						viewmodel.get('btnSnapshot').setVisible(false);
						viewmodel.get("btnSnapshot").setDisabled(true);
					}
				}

				//如果是按品类盘点，那么盘点品类可编辑，否则不可编辑
				if(storeCheckRange != null && storeCheckRange != undefined && storeCheckRange !== '' && storeCheckRange == '1') {
					viewmodel.get("productClass").setDisabled(false);
				} else {
					viewmodel.get("productClass").setDisabled(true);
				}

				//如果是编辑态那么卡片界面上盘点录入页签和盘点复核页签都不可编辑
				viewmodel.execute('updateViewMeta', {
					code: 'luru_yeqian',
					disabled: true,
					refresh: true
				});
				viewmodel.execute('updateViewMeta', {
					code: 'fuhe_yeqian',
					disabled: true
				});

			});
//			viewmodel.on('beforeOutputExecute', function(args) {
//				if(args.params.cCommand === "cmdExport2") {
//					var data = viewmodel.collectData(true);
//					args.params.data = JSON.stringify(data.resultdetails);
//					args.params.partParam = {
//						"entitycode": "st_storecheckplan_result_b_001"
//					};
//				} else {
//					args.params.partParam = {
//						"notentitycode": "st_storecheckplan_result_b_001"
//					};
//				}
//			});
			viewmodel.on('afterLoadData', function() {
				planGridModel.setDirty(true);
				
				var storecheckplanstatus = viewmodel.get('status').getValue();
				
				originSkuRows = viewmodel.get('resultdetails').getRows();
				if(viewmodel.getParams().mode === 'add') {
					//新增态给盘点开始时间设置默认值
					viewmodel.get('checkStartTime').setValue(new Date().format('yyyy-MM-dd hh:mm:ss'));
					//新增态默认盘点范围为整仓盘点，则生成快照按钮可见
					if(viewmodel.get('btnSnapshot')) {
						viewmodel.get('btnSnapshot').setVisible(true);
						viewmodel.get("btnSnapshot").setDisabled(false);
					}
				}

				if(viewmodel.getParams().mode === 'add' &&
					(viewmodel.get('warehouse_name').getValue() == null || viewmodel.get('warehouse_name').getValue() == undefined)) {
					//仓库默认值
					var queryWarehProxy = cb.rest.DynamicProxy.create({
						settle: {
							url: '/billingretail/getDefaultWareh',
							method: 'POST',
							options: {
								async: false
							}
						}
					});
					var data = queryWarehProxy.settle();
					cb.utils.alert("该门店的默认仓库[" + data.result.warehouse_name + "]下存在未复核的快速盘点单，您可以选择其他仓库进行盘点！", 'warning');
				}

				// ====== 查询参数：是否升单 ，生单：联查其他出入库按钮显示否则不显示
				var queryOptionProxy = cb.rest.DynamicProxy.create({
					settle: {
						url: '/option/getOptionsByParams',
						method: 'POST'
					}
				});

				var params = {
					optionId: 'business_option',
					name: 'checkInventorySheetGenerate',
					groupCode: 'bo0102'
				};

				queryOptionProxy.settle(params, (err, result) => {
					if(err) {
						return;
					}

					if(result === undefined) {
						return;
					}

					if(result.length > 0) {
						checkInventorySheetGenerate = result[0].value;
					} else {
						checkInventorySheetGenerate = false;
					}

					// ====== 根据升单参数、浏览态、单据状态 决定：联查按钮 可见性 ======
					if(checkInventorySheetGenerate && viewmodel.getParams().mode === 'browse' && storecheckplanstatus == 1) {
						viewmodel.get("btnQueryOthOut").setVisible(true);
						viewmodel.get("btnQueryOthIn").setVisible(true);
					} else {
						viewmodel.get("btnQueryOthOut").setVisible(false);
						viewmodel.get("btnQueryOthIn").setVisible(false);
					}

				});

				//查询是否为珠宝行业，如果是珠宝行业，那么不显示重量
				var isJewelleryIndustry = cb.rest.DynamicProxy.create({
					settle: {
						url: '/billingretail/isJewelleryIndustry',
						method: 'POST'
					}
				});
				isJewelleryIndustry.settle((err, result) => {
					if(err) {
						return;
					}

					if(result === undefined) {
						return;
					}

					jewelleryIndustry = result;

					// ====== 根据参数设置是否显示重量=====
					if(jewelleryIndustry) {
						planGridModel.setColumnState('accountWeight', 'bShowIt', true);
						resultGridModel.setColumnState('accountWeight', 'bShowIt', true);
						planGridModel.setColumnState('accountPrice', 'bShowIt', true);
						resultGridModel.setColumnState('accountPrice', 'bShowIt', true);
					} else {
						planGridModel.setColumnState('accountWeight', 'bShowIt', false);
						resultGridModel.setColumnState('accountWeight', 'bShowIt', false);
						planGridModel.setColumnState('accountPrice', 'bShowIt', false);
						resultGridModel.setColumnState('accountPrice', 'bShowIt', false);
					}
				});

				//页签是否可以点击
				if(viewmodel.getParams().mode === 'add' || viewmodel.getParams().mode === 'edit' ||
					(storecheckplanstatus != null &&
						storecheckplanstatus != undefined &&
						storecheckplanstatus !== '' &&
						storecheckplanstatus == 2)) {
					//如果是新增态或编辑态，或者已作废，那么卡片界面上盘点录入页签和盘点复核页签都不可编辑
					viewmodel.execute('updateViewMeta', {
						code: 'luru_yeqian',
						disabled: true,
						refresh: true
					});
					viewmodel.execute('updateViewMeta', {
						code: 'fuhe_yeqian',
						disabled: true
					});

				} else { //否则查询后台看那个页签有权限并且可以点击，如果都没有权限就激活盘点录入页签
					if(viewmodel.get('btnSnapshot')) {
						viewmodel.get('btnSnapshot').setVisible(false);
						viewmodel.get("btnSnapshot").setDisabled(true);
					}

					//1. 向后台发送请求，查看当前具有jihuayeqian,fuheyeqian的权限信息
					var getAuth = cb.rest.DynamicProxy.create({
						settle: {
							url: "/user/operation/batchcheck/jihuayeqian,fuheyeqian",
							method: 'GET'
						}
					});
					getAuth.settle((err, result) => {
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}

						if(result === undefined || result == null || result === '') {
							cb.utils.alert("查询权限异常！", 'error');
							return;
						}

						var jihuayeqian = result["jihuayeqian"];
						var fuheyeqian = result["fuheyeqian"];
						viewmodel.setCache("jihuayeqian", jihuayeqian);
						viewmodel.setCache("fuheyeqian", fuheyeqian);

						//如果有复核页签的权限，那么查询复核页签是否可以点击
						if(fuheyeqian) {
							if(jihuayeqian) {
								viewmodel.execute('updateViewMeta', {
									code: 'jihua_yeqian',
									disabled: false
								});
							} else {
								viewmodel.execute('updateViewMeta', {
									code: 'jihua_yeqian',
									disabled: true
								});
							}

							//查看盘点计划对应的所有实盘单的状态,决定盘点复核页签是否可以点击
							var params = {};
							var storecheckplan;
							if(viewmodel.get('id').getValue()) {
								storecheckplan = viewmodel.get('id').getValue();
							}

							if(storecheckplan) {
								params['storecheckplan'] = storecheckplan;

								var getIfReviewTagActive = cb.rest.DynamicProxy.create({
									settle: {
										url: '/billingretail/getIfReviewTagActive',
										method: 'POST'
									}
								});

								getIfReviewTagActive.settle(params, (err, result) => {
									if(err) {
										cb.utils.alert(err.message, 'error');
										return;
									}

									if(result === undefined || result == null || result === '') {
										cb.utils.alert("查询实盘单状态异常！", 'error');
										return;
									}

									if(result === false) {
										viewmodel.execute('updateViewMeta', {
											code: 'fuhe_yeqian',
											disabled: true
										});
										viewmodel.execute('updateViewMeta', {
											code: 'luru_yeqian',
											disabled: false,
											active: true,
											refresh: true
										});
									} else { //实盘单全部审核，那么盘点复核页签可以点击并且被激活
										//如果未复核，那么设置盘点复核页签每次点击的时候都刷新
										if(storecheckplanstatus != null && storecheckplanstatus != undefined && storecheckplanstatus !== '' && storecheckplanstatus == 0) {
											viewmodel.execute('updateViewMeta', {
												code: 'fuhe_yeqian',
												disabled: false,
												active: true,
												refresh: true
											});
											viewmodel.execute('updateViewMeta', {
												code: 'luru_yeqian',
												disabled: false,
												refresh: true
											});
										} else {
											viewmodel.execute('updateViewMeta', {
												code: 'fuhe_yeqian',
												disabled: false,
												active: true,
												refresh: false
											});
											viewmodel.execute('updateViewMeta', {
												code: 'luru_yeqian',
												disabled: false,
												refresh: true
											});
										}
									}

								});
							}
						} else if(jihuayeqian) {
							viewmodel.execute('updateViewMeta', {
								code: 'jihua_yeqian',
								disabled: false,
								active: true
							});
							viewmodel.execute('updateViewMeta', {
								code: 'luru_yeqian',
								disabled: false,
								active: false,
								refresh: true
							});
							viewmodel.execute('updateViewMeta', {
								code: 'fuhe_yeqian',
								disabled: true,
								active: false,
								refresh: false
							});
						} else {
							viewmodel.execute('updateViewMeta', {
								code: 'jihua_yeqian',
								disabled: true,
								active: false
							});
							viewmodel.execute('updateViewMeta', {
								code: 'luru_yeqian',
								disabled: false,
								active: true,
								refresh: true
							});
							viewmodel.execute('updateViewMeta', {
								code: 'fuhe_yeqian',
								disabled: true,
								active: false,
								refresh: false
							});
						}
					});
				}

				//按钮可见性
				if(storecheckplanstatus != null && storecheckplanstatus != undefined && storecheckplanstatus !== '' && storecheckplanstatus == 0 &&
					viewmodel.getParams().mode !== 'add' && viewmodel.getParams().mode !== 'edit') {
					//未复核状态（status = 0）下,并且不是新增态编辑态，作废按钮可见

					if(viewmodel.get('btnInvalidSCPlan')) {
						viewmodel.get('btnInvalidSCPlan').setVisible(true);
					}
					if(viewmodel.get('btnReAudit')) {
						viewmodel.get('btnReAudit').setVisible(true);
					}
					if(viewmodel.get('btnReCheck')) {
						viewmodel.get('btnReCheck').setVisible(true);
					}
					if(viewmodel.get('btnQueryOthOut')) {
						viewmodel.get('btnQueryOthOut').setVisible(false);
					}
					if(viewmodel.get('btnQueryOthIn')) {
						viewmodel.get('btnQueryOthIn').setVisible(false);
					}
					
					if(viewmodel.get('productClass')) {
						viewmodel.get("productClass").setDisabled(true);
					}
					

				} else {
					//否则作废编辑删除不可见

					if(viewmodel.get('btnInvalidSCPlan')) {
						viewmodel.get('btnInvalidSCPlan').setVisible(false);
					}
					if(viewmodel.get('btnEdit')) {
						viewmodel.get('btnEdit').setVisible(false);
					}
					if(viewmodel.get('btnDelete')) {
						viewmodel.get('btnDelete').setVisible(false);
					}
					if(viewmodel.get('btnReAudit')) {
						viewmodel.get('btnReAudit').setVisible(false);
					}
					if(viewmodel.get('btnReCheck')) {
						viewmodel.get('btnReCheck').setVisible(false);
					}
					if(viewmodel.get('btnQueryOthOut')) {
						if(checkInventorySheetGenerate) {
							viewmodel.get('btnQueryOthOut').setVisible(true);
							viewmodel.get('btnQueryOthOut').setDisabled(false);
						} else {
							viewmodel.get('btnQueryOthOut').setVisible(false);
						}
					}
					if(viewmodel.get('btnQueryOthIn')) {
						if(checkInventorySheetGenerate) {
							viewmodel.get('btnQueryOthIn').setVisible(true);
							viewmodel.get('btnQueryOthIn').setDisabled(false);
						} else {
							viewmodel.get('btnQueryOthIn').setVisible(false);
						}
					}

					//如果是按品类盘点，那么盘点品类可编辑，否则不可编辑
					var storeCheckRange = viewmodel.get("storeCheckRange").getValue();
					if(storeCheckRange != null && storeCheckRange != undefined && storeCheckRange !== '' && storeCheckRange == '1') {
						viewmodel.get("productClass").setDisabled(false);
					} else {
						viewmodel.get("productClass").setDisabled(true);
					}
				}

				if(storecheckplanstatus != null && storecheckplanstatus != undefined && storecheckplanstatus !== '' && storecheckplanstatus == 2 &&
					viewmodel.getParams().mode == 'browse') {
					if(viewmodel.get('btnSnapshot')) {
						viewmodel.get('btnSnapshot').setVisible(false);
						viewmodel.get("btnSnapshot").setDisabled(true);
					}
				}

			});

			//作废
			viewmodel.on('invalidSCPlan', function(args) {
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: args.cSvcUrl,
						method: 'POST'
					}
				});

				var datas = {
					storecheckplan: viewmodel.get('id').getValue()
				}
				var params = {
					billnum: "st_storecheckplan",
					data: JSON.stringify(datas)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					cb.utils.alert('操作成功', 'success');

					if(viewmodel.get('btnInvalidSCPlan')) {
						viewmodel.get('btnInvalidSCPlan').setVisible(false);
					}
					if(viewmodel.get('btnEdit')) {
						viewmodel.get('btnEdit').setVisible(false);
					}
					if(viewmodel.get('btnDelete')) {
						viewmodel.get('btnDelete').setVisible(false);
					}
					if(viewmodel.get('btnSnapshot')) {
						viewmodel.get('btnSnapshot').setVisible(false);
						viewmodel.get("btnSnapshot").setDisabled(true);
					}

					viewmodel.execute('updateViewMeta', {
						code: 'luru_yeqian',
						disabled: true
					});
					viewmodel.execute('updateViewMeta', {
						code: 'fuhe_yeqian',
						disabled: true
					});
					viewmodel.execute('refresh');
				});
			});

			//编辑
			viewmodel.on('beforeEdit', function(args) {
				var storecheckplanstatus = viewmodel.get('status').getValue();
				//如果未复核并且没有下有单据，那么允许编辑，否则不允许编辑
				if(storecheckplanstatus != null && storecheckplanstatus != undefined && storecheckplanstatus !== '' && storecheckplanstatus == '0') {
					var params = {
						storecheckplan: viewmodel.get('id').getValue()
					};
					var existSCReality = cb.rest.DynamicProxy.create({
						settle: {
							url: '/billingretail/existSCReality',
							method: 'POST'
						}
					});

					var promise = new cb.promise();

					existSCReality.settle(params, (err, result) => {
						if(err) {
							cb.utils.alert(err.message, 'error');
						}

						if(result === undefined || result == null || result === '') {
							cb.utils.alert("查询实盘单异常！", 'error');
						}

						if(result === true) {
							cb.utils.alert("已产生下游实盘单的计划不允许编辑！");
						} else {
							promise.resolve();
						}
					});

					return promise;
				} else {
					cb.utils.alert("已审核的计划不允许编辑！");
					return false;
				}
			});

			//删除
			viewmodel.on('beforeDelete', function(args) {
				var storecheckplanstatus = viewmodel.get('status').getValue();
				//如果未复核并且没有下有单据，那么允许删除，否则不允许删除
				if(storecheckplanstatus != null && storecheckplanstatus != undefined && storecheckplanstatus !== '' && storecheckplanstatus == '0') {
					var params = {
						storecheckplan: viewmodel.get('id').getValue()
					};
					var existSCReality = cb.rest.DynamicProxy.create({
						settle: {
							url: '/billingretail/existSCReality',
							method: 'POST'
						}
					});

					var promise = new cb.promise();

					existSCReality.settle(params, (err, result) => {
						if(err) {
							cb.utils.alert(err.message, 'error');
						}

						if(result === undefined || result == null || result === '') {
							cb.utils.alert("查询实盘单异常！", 'error');
						}

						if(result === true) {
							cb.utils.alert("已产生下游实盘单的计划不允许删除！");
						} else {
							promise.resolve();
						}
					});
					return promise;
				} else {
					cb.utils.alert("已审核的计划不允许删除！");
					return false;
				}
			});

			viewmodel.on('afterSave', function(args) {
				if(args.err) {
					if(args.err.message.split("！")[1]) {
						if(args.err.message.split("！")[1].length > 0) {
							var indexes = args.err.message.split("！")[1].split(",");
							for(var i = 0; i < indexes.length - 1; i++) {
								planGridModel.setRowState(indexes[i], 'className', 'highlight-red');
							}
							cb.utils.alert("存在未复核的盘点计划中有如下商品，不能重复盘点！", 'error');
						}
					}else{
						cb.utils.alert(args.err.message, 'error');
					}
					return false;
				} else {
					viewmodel.execute('updateViewMeta', {
						code: 'luru_yeqian',
						disabled: false,
						active: true
					});
				}

				//保存之前界面上有很多行，保存的时候可能会剔除一些行，保存完以后要刷新一下，使界面只显示已经保存了的行
				//						viewmodel.execute('refresh');
				//
				//						if(args.res.excludeSkucodes != null && args.res.excludeSkucodes != undefined && args.res.excludeSkucodes !== '') {
				//							var excludeSkucodes = args.res.excludeSkucodes;
				//							var info = '以下[sku编码，批号]由于存在于其他未复核的盘点计划中，所以从本次盘点范围内剔除： ' + excludeSkucodes;
				//							viewmodel.communication({
				//								type: 'modal',
				//								payload: {
				//									mode: 'html',
				//									html: '<textarea style="width:100%;height:250px;">' + info + '</textarea>'
				//								}
				//							});
				//							cb.utils.alert("存在未复核的盘点计划中有如下商品，不能重复盘点！", 'error');
				//						} else {
				//							viewmodel.execute('updateViewMeta', {
				//								code: 'luru_yeqian',
				//								disabled: false,
				//								active: true
				//							});
				//						}

			});

			//盘点范围的值变化前
			viewmodel.get("storeCheckRange").on('beforeValueChange', function(data) {
				if(planGridModel.getRows().length) {
					if(viewmodel.get("productClass").getValue() != null && viewmodel.get("productClass").getValue() != undefined && viewmodel.get("productClass").getValue() !== '' && viewmodel.get("productClass").getValue().length > 0) {
						var promise = new cb.promise();

						cb.utils.confirm('改变盘点范围将会清空盘点品类和表体明细数据，是否继续？', function() {
							promise.resolve();
							self.deleteAllItems(viewmodel.get("productClass"));
							self.deleteAllRows(planGridModel);
						});

						return promise;
					} else {
						var promise = new cb.promise();

						cb.utils.confirm('改变盘点范围将会清空表体明细数据，是否继续？', function() {
							promise.resolve();
							self.deleteAllRows(planGridModel);
						});

						return promise;
					}
				} else if(viewmodel.get("productClass").getValue() != null && viewmodel.get("productClass").getValue() != undefined && viewmodel.get("productClass").getValue() !== '' && viewmodel.get("productClass").getValue().length > 0) {
					var promise = new cb.promise();

					cb.utils.confirm('改变盘点范围将会清空盘点品类，是否继续？', function() {
						promise.resolve();
						self.deleteAllItems(viewmodel.get("productClass"));
					});

					return promise;
				}
			});

			//盘点品类值改变之前，如果表体行有值，那么提示清空表体行
			//			viewmodel.get("productClass").on('beforeBrowse', function(data) {
			//				if(planGridModel.getRows().length) {
			//					var promise = new cb.promise();
			//
			//					cb.utils.confirm('改变盘点品类将会清空表体明细数据，是否继续？', function() {
			//						promise.resolve();
			//						self.deleteAllRows(planGridModel);
			//					});
			//
			//					return promise;
			//				}
			//			});
			viewmodel.get("productClass").on('beforeValueChange', function(data) {
				if(planGridModel.getRows().length) {
					var promise = new cb.promise();

					cb.utils.confirm('改变盘点品类将会清空表体明细数据，是否继续？', function() {
						promise.resolve();
						self.deleteAllRows(planGridModel);
					});

					return promise;
				}
			});

			//盘点范围的值变化后
			viewmodel.get("storeCheckRange").on('afterValueChange', function(data) {
				var storeCheckRange = viewmodel.get("storeCheckRange").getValue();

				//如果是整仓盘点0或指定品类1，那么生成快照按钮可见，否则不可见
				if(storeCheckRange != null && storeCheckRange != undefined && storeCheckRange !== '' &&
					(storeCheckRange == '0' || storeCheckRange == '1')) {

					if(viewmodel.get('btnSnapshot')) {
						viewmodel.get('btnSnapshot').setVisible(true);
						viewmodel.get("btnSnapshot").setDisabled(false);
					}
				} else {

					if(viewmodel.get('btnSnapshot')) {
						viewmodel.get('btnSnapshot').setVisible(false);
						viewmodel.get("btnSnapshot").setDisabled(true);
					}
				}

				//如果是按品类盘点，那么盘点品类可编辑，否则不可编辑
				if(storeCheckRange != null && storeCheckRange != undefined && storeCheckRange !== '' && storeCheckRange == '1') {
					viewmodel.get("productClass").setDisabled(false);
				} else {
					viewmodel.get("productClass").setDisabled(true);
				}
			});

			//仓库变化之前，如果表体行有值，那么提示清空
			//			viewmodel.get("warehouse_name").on('beforeBrowse', function(data) {
			//				if(planGridModel.getRows().length) {
			//					var promise = new cb.promise();
			//
			//					cb.utils.confirm('改变仓库将会清空表体明细数据，是否继续？', function() {
			//						promise.resolve();
			//						self.deleteAllRows(planGridModel);
			//					});
			//
			//					return promise;
			//				}
			//			});

			//仓库变化
			//1. 查询是否存在未复核的快速盘点，如果存在，不允许值变化
			//2. 提示仓库变化将会清空表体行
			viewmodel.get("warehouse_name").on('beforeValueChange', function(data) {
				var promise = new cb.promise();
				if(data.value) { //选了另一个仓库
					var wareh = data.value.id;
					var params = {
						wareh: wareh
					};
					var existStoreCheck = cb.rest.DynamicProxy.create({
						settle: {
							url: '/billingretail/existStoreCheck',
							method: 'POST'
						}
					});

					existStoreCheck.settle(params, (err, result) => {
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}

						if(result === undefined) {
							cb.utils.alert("查询快速盘点异常！", 'error');
							return;
						}

						if(result != null && result != undefined && result !== '') {
							if(result == false || result == 'false') { //如果不冲突,允许切换
								//如果有表体行，提示改变仓库将会清空表体行
								if(planGridModel.getRows().length) {
									cb.utils.confirm('改变仓库将会清空表体明细数据，是否继续？', function() {
										promise.resolve();
										self.deleteAllRows(planGridModel);
									});
								} else { //没有表体行，直接切换
									promise.resolve();
								}
							} else {
								cb.utils.alert("该仓库下存在未复核的快速盘点单，不允许新增盘点计划！", 'error');
							}
						}

					});
				} else { //清空当前仓库的值
					if(planGridModel.getRows().length) {
						cb.utils.confirm('改变仓库将会清空表体明细数据，是否继续？', function() {
							promise.resolve();
							self.deleteAllRows(planGridModel);
						});
					} else {
						return true;
					}
				}

				return promise;
			});

			//增行前，先指定仓库、盘点范围或盘点品类
			viewmodel.on('beforeAddRow', function() {
				//如果没有选择仓库提示先选仓库
				//				viewmodel.get('warehouse_name').validate();
				var warehouse = viewmodel.get("warehouse").getValue();
				if(warehouse == undefined || warehouse == null || warehouse == '') {
					cb.utils.alert("请先设置仓库！");
					return false;
				}

				//如果没有选择盘点范围提示先选盘点范围
				//				viewmodel.get('storeCheckRange').validate();
				var storeCheckRange = viewmodel.get("storeCheckRange").getValue();
				if(storeCheckRange == undefined || storeCheckRange == null || storeCheckRange === '') {
					cb.utils.alert("请先设置盘点范围！");
					return false;
				}

				//如果盘点范围是按照品类盘点，却没有选择盘点品类 提示先选盘点品类
				if(storeCheckRange != undefined && storeCheckRange != null && storeCheckRange !== '' && storeCheckRange == '1') {
					//					viewmodel.get('productClass_name').validate();
					var productClass = viewmodel.get("productClass").getValue();
					if(productClass == null || storeCheckRange == undefined || productClass === '' || productClass.length == 0) {
						cb.utils.alert("请先选择盘点品类！");
						return false;
					}
				}
			});

			//点击生成快照时，向后台发送请求，查询出所有符合条件的商品行，在表体上显示
			viewmodel.on('snapshot', function() {
				//如果没有选择仓库提示先选仓库
				//				viewmodel.get('warehouse_name').validate();
				var warehouse = viewmodel.get("warehouse").getValue();
				if(warehouse == undefined || warehouse == null || warehouse == '') {
					cb.utils.alert("请先设置仓库！");
					return false;
				}

				//如果盘点范围是指定品类盘点，那么如果商品分类子表为空，提示先选择商品分类
				var productclasses = [];
				var storeCheckRange = viewmodel.get("storeCheckRange").getValue();
				if(storeCheckRange != null && storeCheckRange != undefined && storeCheckRange !== '' && storeCheckRange == '1') {
					var productClass = viewmodel.get("productClass").getValue();
					if(productClass == null || storeCheckRange == undefined || productClass === '' || productClass.length == 0) {
						cb.utils.alert("请先选择商品分类！");
						return false;
					}
					for(var i = 0; i < productClass.length; i++) {
						productclasses[i] = productClass[i].productClass;
					}
				}

				//否则向后台发送请求，查询商品明细
				var params = {
					tenant: cb.rest.AppContext.tenant.id,
					store: viewmodel.get("store").getValue(),
					warehouse: warehouse,
					//					productclasses: productclasses,
					storeCheckRange: viewmodel.get('storeCheckRange').getValue(),
					from: "0" //0表示该请求来自生成快照按钮，1表示该请求来自增行
				};

				if(productclasses.length > 0) {
					params["productclasses"] = productclasses;
				}

				var queryStockBatch = cb.rest.DynamicProxy.create({
					settle: {
						url: '/billingretail/getStockBatch',
						method: 'POST'
					}
				});

				queryStockBatch.settle(params, (err, result) => {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}

					if(result === undefined) {
						cb.utils.alert("查询商品库存、批次、效期异常！", 'error');
						return;
					}
					//					checkStartTime = new Date().format('yyyy-MM-dd hh:mm:ss');
					// planGridModel.insertRows(0,[{b:'',a:'',c:''}]);
					self.deleteAllRows(planGridModel);

					if(result.productskusInfolist != null && result.productskusInfolist != undefined && result.productskusInfolist !== '') {
						if(result.productskusInfolist.length > 0) {
							planGridModel.insertRows(0, result.productskusInfolist);
						} else {
							cb.utils.alert("该范围内未查询到存量信息，不可以通过生成快照添加商品！", 'warning');
						}
					}
				});
			});

			if(resultGridModel) {
				//业务发生数量的值变化以后，改变盈亏数量
				resultGridModel.on('afterCellValueChange', function(data) {
					switch(data.cellName) {
						case "occurredqty":
							{
								var quantity = 0;
								if(this.getCellValue(data.rowIndex, 'quantity')) {
									quantity = this.getCellValue(data.rowIndex, 'quantity');
								}
								var accountQty = 0;
								if(this.getCellValue(data.rowIndex, 'accountQty')) {
									accountQty = this.getCellValue(data.rowIndex, 'accountQty');
								}
								var occurredqty = 0;
								if(this.getCellValue(data.rowIndex, 'occurredqty')) {
									occurredqty = this.getCellValue(data.rowIndex, 'occurredqty');
								}
								this.setCellValue(data.rowIndex, 'profitlossqty', quantity - accountQty - occurredqty);

								originSkuRows = resultGridModel.getRows();

								break;
							}
					}

				});

			}

			if(planGridModel) {
				//向后台传递行号
				planGridModel.setState('orderField', 'rowno');

				//单元格编辑之前判断该行商品批号是否可以编辑
				planGridModel.on('rowColChange', function(args) {
					if(args.value.columnKey == 'batchno') {
						var canbEdit = common.bacthnoAndExpiryDateManage(args, planGridModel);
						if(canbEdit == true) {
							//如果是批次管理，需要进一步判断批次号是否为空，批次号为空才允许编辑
							var currentRow = planGridModel.getRow(args.value.rowIndex);
							if(currentRow.batchno == null && currentRow.batchno == undefined) {
								return true;
							} else {
								return false;
							}
							//							return true;
						} else {
							return false;
						}
					}
				});

				//参照弹出之前如果仓库为空，提示先设置仓库
				planGridModel.on('beforeBrowse', function(data) {
					//					viewmodel.get('warehouse_name').validate();
					var warehouseid = viewmodel.get("warehouse").getValue();
					if(warehouseid == undefined || warehouseid == null || warehouseid == '') {
						cb.utils.alert("请先设置仓库！");
						return false;
					}
				});

				//批号清空，自定义项清空
				//				planGridModel.on('afterCellValueChange', function(data) {
				//					switch(data.cellName) {
				//						case "batchno":
				//							{
				//								this.setCellValue(data.rowIndex, 'define1', null);
				//								break;
				//							}
				//					}
				//
				//				});

				//选择完sku之后，商品落到表体行之前，请求后台，处理数据
				planGridModel.on("beforeInsertRowsFromRefer", function(args) {
					var promise = new cb.promise();
					var store = viewmodel.get("store").getValue();
					//					viewmodel.get('warehouse_name').validate();
					var warehouse = viewmodel.get("warehouse").getValue();
					if(warehouse == undefined || warehouse == null || warehouse == '') {
						cb.utils.alert("请先设置仓库！");
						return false;
					}
					var productskus = [];
					var productskurows = args.rows;
					if(productskurows != 'undefined' && productskurows != null && productskurows.length > 0) {
						for(var i = 0; i < productskurows.length; i++) {
							productskus[i] = productskurows[i].productsku;
						}
					}
					var params = {
						tenant: cb.rest.AppContext.tenant.id,
						store: store,
						storeCheckRange: viewmodel.get("storeCheckRange").getValue(),
						warehouse: warehouse,
						from: '1' //0表示该请求来自生成快照按钮，1表示该请求来自增行
					};

					if(productskus.length > 0) {
						params["productskus"] = productskus;
					}

					var queryStockBatch = cb.rest.DynamicProxy.create({
						settle: {
							url: '/billingretail/getStockBatch',
							method: 'POST'
						}
					});

					queryStockBatch.settle(params, (err, result) => {
						// getGridModel.insertRows(0,[{b:'',a:'',c:''}]);
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}

						if(result === undefined) {
							cb.utils.alert("查询商品库存、批次、效期异常！", 'error');
							return;
						}

						if(result.productskusInfolist != null && result.productskusInfolist != undefined && result.productskusInfolist !== '' && result.productskusInfolist.length > 0) {
							//组装已经存在于表体行上的商品行，使下面不能重复添加

							//由于args.rows中会包含从参照上带出来的行，所以要先清空，再吧后台返回的行设置到args.rows中
							args.rows.splice(0, args.rows.length);
							var existsSkucodeBatch = '';
							for(var i = 0; i < result.productskusInfolist.length; i++) {
								//对于每一行，检查是否已经存在，检查维度：sku+batchno
								var row = result.productskusInfolist[i];
								if(eXist(row) == false) {
									args.rows.splice(-1, 0, row);
								} else {
									existsSkucodeBatch += eXist(row)
								}
							}
							if(existsSkucodeBatch !== '') {
								cb.utils.alert(existsSkucodeBatch, 'warning');
							}
						}
						promise.resolve();
					});
					return promise;
				});
			}

			var eXist = function(row) {
				var existsSkucodeBatch = false;
				var rows = planGridModel.getRows();
				var rowLength = rows.length;

				for(var i = 0; i < rowLength; i++) {
					if(rows[i]._status == 'Delete') {
						continue;
					}

					if(row.productsku == planGridModel.getCellValue(i, 'productsku')) {
						if(row.isBatchManage) {
							if(row.batchno == planGridModel.getCellValue(i, 'batchno')) {
								if(row.batchno != null && row.batchno != undefined && row.batchno !== '') {
									existsSkucodeBatch = 'sku编码为' + row.productsku_cCode + ',批次号为' + row.batchno + '的商品已存在于表体行中，不能重复添加！';
								} else {
									existsSkucodeBatch = 'sku编码为' + row.productsku_cCode + '的商品已存在于表体行中，不能重复添加！';
								}
								break;
							}
						} else {
							existsSkucodeBatch = 'sku编码为' + row.productsku_cCode + '的商品已存在于表体行中，不能重复添加！';
							break;
						}
					}
				}
				return existsSkucodeBatch;
			};

			//复核
			viewmodel.on('reaudit', function(args) {
				var url = '/bill/reaudit';
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: url,
						method: 'POST',
						options: {mask:true}
					}
				});

				var storeCheckPlan = viewmodel.collectData();
				storeCheckPlan.details = null;
				var datas = {
					billnumber: "st_storecheckplan",
					storecheckplan: viewmodel.get('id').getValue(),
					data: storeCheckPlan,
					resultdetails: originSkuRows
				}
				var params = {
					billnum: "st_storecheckplan",
					data: JSON.stringify(datas)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}

					viewmodel.execute('refresh');

					if(viewmodel.get('btnReAudit')) {
						viewmodel.get('btnReAudit').setVisible(false);
					}
					if(viewmodel.get('btnReCheck')) {
						viewmodel.get('btnReCheck').setVisible(false);
					}
					if(viewmodel.get('btnQueryOthOut')) {
						if(checkInventorySheetGenerate) {
							viewmodel.get('btnQueryOthOut').setVisible(true);
							viewmodel.get('btnQueryOthOut').setDisabled(false);
						} else {
							viewmodel.get('btnQueryOthOut').setVisible(false);
						}
					}
					if(viewmodel.get('btnQueryOthIn')) {
						if(checkInventorySheetGenerate) {
							viewmodel.get('btnQueryOthIn').setVisible(true);
							viewmodel.get('btnQueryOthIn').setDisabled(false);
						} else {
							viewmodel.get('btnQueryOthIn').setVisible(false);
						}
					}
					cb.utils.alert('操作成功', 'success');
					//成功以后，设置盘点录入页签为每次进入都刷新
					viewmodel.execute('updateViewMeta', {
						code: 'luru_yeqian',
						disabled: false,
						active: false,
						refresh: true
					});
					viewmodel.execute('afterReaudit');
				});
			});

			//联查其他出库单
			viewmodel.on('queryothout', function(args) {
				var originid = viewmodel.get('id').getValue();
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: args.cSvcUrl,
						method: args.cHttpMethod
					}
				});
				var params = {
					action: 'queryothout',
					billnum: 'st_storecheckplan',
					data: JSON.stringify(originid)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					if(result != undefined) {
						// cb.utils.alert('操作成功', 'success');
						viewmodel.execute('refresh');
						var params = {
							mode: 'edit',
							readOnly: true,
							id: JSON.parse(result).id
						};
						var data = {
							billtype: 'voucher',
							billno: JSON.parse(result).billno,
							params: params
						};
						cb.loader.runCommandLine('bill', data, viewmodel);
					}

				});
			});
			//联查其他入库单
			viewmodel.on('queryothin', function(args) {
				var originid = viewmodel.get('id').getValue();
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: args.cSvcUrl,
						method: args.cHttpMethod
					}
				});
				var params = {
					action: 'queryothin',
					billnum: 'st_storecheckplan',
					data: JSON.stringify(originid)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					// cb.utils.alert('操作成功', 'success');
					viewmodel.execute('refresh');
					var params = {
						mode: 'edit',
						readOnly: true,
						id: JSON.parse(result).id
					};
					var data = {
						billtype: 'voucher',
						billno: JSON.parse(result).billno,
						params: params
					};
					cb.loader.runCommandLine('bill', data, viewmodel);
				});
			});

			//复盘
			viewmodel.on('recheck', function(args) {
				var selectedRows = resultGridModel.getSelectedRows();
				if(selectedRows == null || selectedRows == undefined || selectedRows === '' || selectedRows.length == 0) {
					cb.utils.alert('请选择需要复盘的商品！', 'warning');
					return false;
				}
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: args.cSvcUrl,
						method: args.cHttpMethod,
						options: {mask:true}
					}
				});
				var datas = {
					billnumber: "st_storecheckplan",
					storecheckplan: viewmodel.get('id').getValue(),
					warehouse: viewmodel.get('warehouse').getValue(),
					storeCheckRange: viewmodel.get("storeCheckRange").getValue(),
					selectedRows: selectedRows
				}
				var params = {
					billnum: "st_storecheckplan",
					data: JSON.stringify(datas)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					cb.utils.alert('操作成功', 'success');
					//					viewmodel.execute('refresh');
					//成功以后，跳转到盘点录入页签，同时设置盘点复核页签不可编辑
					viewmodel.execute('updateViewMeta', {
						code: 'luru_yeqian',
						disabled: false,
						active: true,
						refresh: true
					});
					viewmodel.execute('updateViewMeta', {
						code: 'fuhe_yeqian',
						disabled: true,
						active: false,
						refresh: true
					});
				});

			});

			//单据状态的值变化以后，如果是已复核，那么复核、复盘不可见，联查、打印按钮可见
			viewmodel.get("status").on('afterValueChange', function(data) {
				var status = viewmodel.get("status").getValue();

				//如果是已复核
				if(status != null && status != undefined && status !== '' && status == '1') {
					if(viewmodel.get('btnReAudit')) {
						viewmodel.get('btnReAudit').setVisible(false);
					}
					if(viewmodel.get('btnReCheck')) {
						viewmodel.get('btnReCheck').setVisible(false);
					}
					if(viewmodel.get('btnQueryOthOut')) {
						if(checkInventorySheetGenerate) {
							viewmodel.get('btnQueryOthOut').setVisible(true);
							viewmodel.get('btnQueryOthOut').setDisabled(false);
						} else {
							viewmodel.get('btnQueryOthOut').setVisible(false);
						}
					}
					if(viewmodel.get('btnQueryOthIn')) {
						if(checkInventorySheetGenerate) {
							viewmodel.get('btnQueryOthIn').setVisible(true);
							viewmodel.get('btnQueryOthIn').setDisabled(false);
						} else {
							viewmodel.get('btnQueryOthIn').setVisible(false);
						}
					}
				}

			});

		}
	};

	try {
		module.exports = ST_st_storecheckplan_VM_Extend;
	} catch(error) {

	}
	return ST_st_storecheckplan_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storecheckplan_VM.Extend.js